<atx-searchable-contacts-list
  [contacts$]="contacts$"
  [hyperlinkEmail]="true"
></atx-searchable-contacts-list>
